import request from "@/utils/request";

/**
 * 同意借呗协议接口
 *
 * @description 同意借呗协议接口（该接口会初始化用户借呗额度、已借金额、冻结福利等信息）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function permitJiebeiConduct(playload, config) {
  return request({
    url: "/api/v2/conduct/permitJiebeiConduct",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}

/**
 * 获取借呗基础配置信息接口
 *
 * @description 获取借呗基础配置信息接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function getUserJiebeiInfo(playload, config) {
  return request({
    url: "/api/v2/conduct/getUserJiebeiInfo",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

/**
 * 借呗借款接口
 *
 * @description 借呗借款接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function borrowFromJiebei(playload, config) {
  return request({
    url: "/api/v2/conduct/borrowFromJiebei",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}

/**
 * 借呗还款接口
 *
 * @description 借呗还款接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function repaymentJiebei(playload, config) {
  return request({
    url: "/api/v2/conduct/repaymentJiebei",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}

/**
 * 获取借呗借款记录接口
 *
 * @description 获取借呗借款记录接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryBorrowList(playload, config) {
  return request({
    url: "/api/v2/conduct/queryBorrowList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

/**
 * 获取借呗还款记录接口
 *
 * @description 获取借呗还款记录接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryRepaymentList(playload, config) {
  return request({
    url: "/api/v2/conduct/queryRepaymentList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

/**
 * 获取借呗待还款记录接口
 *
 * @description 获取借呗待还款记录接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryPaymentList(playload, config) {
  return request({
    url: "/api/v2/conduct/queryPaymentList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

/**
 * 查询具有彩票房功能的彩种信息
 *
 * @description 查询具有彩票房功能的彩种信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryRoomLotterys(playload, config) {
  return request({
    url: "/api/v2/conduct/queryRoomLotterys",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 * 创建彩票房（加密）
 *
 * @description 创建彩票房（加密）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function createLotteryRoom(playload, config) {
  return request({
    url: "/api/v2/conduct/createLotteryRoom",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}

/**
 * 根据专区编码、房间号模糊查询房间
 *
 * @description 根据专区编码、房间号模糊查询房间
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotteryRoomByAreaAndNo(playload, config) {
  return request({
    url: "/api/v2/conduct/queryLotteryRoomByAreaAndNo",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

/**
 * 根据专区编码查询房间
 *
 * @description 根据专区编码查询房间
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotteryRoomByArea(playload, config) {
  return request({
    url: "/api/v2/conduct/queryLotteryRoomByArea",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

/**
 * 查询彩票房公告
 *
 * @description 查询彩票房公告
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotteryRoomNotice(playload, config) {
  return request({
    url: "/api/v2/conduct/queryLotteryRoomNotice",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 * 根据房间号、彩种期数ID查询庄家信息
 *
 * @description 根据房间号、彩种期数ID查询庄家信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotteryRoomBankerInfo(playload, config) {
  return request({
    url: "/api/v2/conduct/queryLotteryRoomBankerInfo",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

/**
 * 抢庄或者退出抢庄队列（加密）
 *
 * @description 抢庄或者退出抢庄队列（加密）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function joinOrQuitBankerQueue(playload, config) {
  return request({
    url: "/api/v2/conduct/joinOrQuitBankerQueue",
    method: "POST",
    data: playload,
    userId: true,
    ...config
  });
}

/**
 * 查询用户是否已经在指定房间中抢庄过
 *
 * @description 查询用户是否已经在指定房间中抢庄过
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryExistInBankerQueue(playload, config) {
  return request({
    url: "/api/v2/conduct/queryExistInBankerQueue",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

/**
 * 查询抢庄房庄主排队列表排名信息
 *
 * @description 查询抢庄房庄主排队列表排名信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryRoomBankerQueue(playload, config) {
  return request({
    url: "/api/v2/conduct/queryRoomBankerQueue",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true,
    ...config
  });
}

/**
 * 查询抢庄房开放时间描述
 *
 * @description 查询抢庄房开放时间描述
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryRoomOpenTime(playload, config) {
  return request({
    url: "/api/v2/conduct/queryRoomOpenTime",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 * 186.继续做庄（加密）
 *
 * @description 继续做庄
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function becomeRoomBanker(playload, config) {
  return request({
    url: "/api/v2/conduct/becomeRoomBanker",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 *  查询庄家在指定抢庄房中的做庄盈利情况
 *
 * @description 查询庄家在指定抢庄房中的做庄盈利情况
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryBankerProfitRecord(playload, config) {
  return request({
    url: "/api/v2/conduct/queryBankerProfitRecord",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 *  查询抢庄房当前是否在开放时间范围内
 *
 * @description 查询抢庄房当前是否在开放时间范围内
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotteryRoomStatus(playload, config) {
  return request({
    url: "/api/v2/conduct/queryLotteryRoomStatus",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 *  188.查询抢庄房专区列表
 *
 * @description 188.查询抢庄房专区列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryRoomAreas(playload, config) {
  return request({
    url: "/api/v2/conduct/queryRoomAreas",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 *  189.放弃继续做庄（加密）
 *
 * @description 189.放弃继续做庄（加密）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function giveUpBecomeBanker(playload, config) {
  return request({
    url: "/api/v2/conduct/giveUpBecomeBanker",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
